module.exports = "https://static.energy5.com/_next/static/images/logo-0a9cc272aba44d0932f80bf031c862e3.png";